import { React, useEffect, useState } from 'react';
import * as Yup from 'yup';

import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

// material
import { styled } from '@mui/material/styles';
import { Stack, Tooltip, Card, Typography, Divider, Button, TextField, Grid, Box, FormControl, InputLabel, Select, MenuItem, IconButton, Modal, Autocomplete } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import Iconify from '../../../components/Iconify';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';

// components
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from '../../../components/Page';
import Scrollbar from "../../../components/Scrollbar";
import { handleError } from '../../../components/Common/Utils';
import ModalPopUp from '../../../components/Common/ModalPopUp';
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
export default function RCAReason() {
    const firstSectionColumn = [
        { field: 'reason', headerName: 'Reason', flex: 1 },
        { field: 'visibleOn', headerName: 'Visible On', flex: 1 },
        { field: 'department', headerName: 'Department', flex: 1 },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            align: 'right',
            headerAlign: 'right',
            flex: 1,
            renderCell: (cellValues) => {
                return (<div>

                    <IconButton
                        onClick={(event) => {
                            handleOpenModal(event, cellValues);
                        }}><Iconify icon="ic:outline-edit" width='20px' height='20px' color='primary.main' /></IconButton>

                </div>
                );
            }
        },

    ];
    const visibleOnData = [
        {
            Id: 0,
            Value:'Observation + RCA'
        },
        {
            Id: 1,
            Value: 'Only Observation'
        },
        {
            Id: 2,
            Value: 'Only RCA'
        },
        {
            Id: null, Name: "Not defined"
        },
  ]
    const location = useLocation()

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [userId, setUserId] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const [reason, setReason] = useState('');

    const [visibleOn, setVisibleOn] = useState('');
    const [selectedVisibleOn, setSelectedVisibleOn] = useState([]);

    const [department, setDepartment] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);

    const [rowReasonTxt, setRowReasonTxt] = useState('');

    const [rowVisibleOn, setRowVisibleOn] = useState('');
    const [rowSelectedVisibleOn, setRowSelectedVisibleOn] = useState([]);

    const [rowDepartment, setRowDepartment] = useState([]);
    const [rowSelectedDepartment, setRowSelectedDepartment] = useState([]);

    const [rcaData, setRcaData] = useState([
        {
            id: 1,
            reason: 'Incorrect Customer Info',
            visibleOn: 'Observation + RCA', // Observation + RCA
        },
        {
            id: 2,
            reason: 'Delay in Delivery',
            visibleOn: ' Only Observation', // Only Observation
        },
        {
            id: 3,
            reason: 'Product Not Working',
            visibleOn: ' Only RCA', // Only RCA
        },
        {
            id: 4,
            reason: 'Incomplete Installation',
            visibleOn: null, // Not Defined
        },
    ]);
  
    const [editModal, setEditModal] = useState(false);
    const [pageSize, setPageSize] = useState(25);


    useEffect(() => {
        setUserId(CurrentLoggedInUser.ExecutiveId);

    }, []);

    useEffect(() => {

        URLS.getDepartmentDropDown()
            .then((response) => {
                setSelectedDepartment(response.data);
                setRowSelectedDepartment(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });


    }, []);

    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            setEditModal(false);

            setOpenModalCancel(false);
        }
        else {
            setOpenModalCancel(false);
        }
    };

    const handelCancelClick = () => {
        setOpenModalCancel(true);
    };
    const handleVisibleOn = (value) => {
        setVisibleOn(value)
    }
    const handleReason = (e) => {
        setReason(e.target.value)
    }
    const handleDepartment = (value) => {
        setDepartment(value); 
    };
    const handleRowDepartment = (value) => {
        setRowDepartment(value);
    };
    const handleRowReason = (e) => {
        setRowReasonTxt(e.target.value)
    }
    const handleRowVisibleOn = (value) => {
        setRowVisibleOn(value)
    }
    
    const handleOpenModal = () => {
        setEditModal(true);
    }
    const handleCloseModal = () => {
        setEditModal(false);
    }
    const handleRCASave = () => {
        setEditModal(false);
    }

     const onFilterClick = () => {

    }
    const handleReset = () => {
        setReason("");
        setVisibleOn("");
        setDepartment([]);
        setRcaData([]);
    }
        const ClientMasterSchema = Yup.object().shape({
            ClientName: Yup.string()
                .min(2, 'Too Short!')
                .max(100, 'Too Long!')
                .required('Client Name is required'),
            ERPCode: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('ERP Code is required'),

        });

        const formik = useFormik({
            initialValues: {

            },
            validationSchema: ClientMasterSchema,

            onSubmit: (values, actions) => {

                const payload = {}

                console.log("Payload  in ClientMasterDetailsPage ", payload);
            },
        });


        const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

        return (

            <Page title="RCA Reason" >
              
                <StickyHeader title=" RCA Reason" />

                <Card >
                   
                   
                    <Stack direction="row" alignItems="center" justifyContent="space-between" m={1} spacing={1}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Reason "
                            multiline
                            maxRows={2}
                            value={reason}
                            onChange={handleReason}
                        />
                        <FormControl
                            fullWidth
                            size="small">
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Visible On</InputLabel>
                            <Select
                                label="Visible On"
                                size="small"
                                value={visibleOn}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}>
                                <MenuItem key={0} value={""} onClick={() => handleVisibleOn()}  >Select</MenuItem>
                                {visibleOnData.map((component) => (
                                    <MenuItem key={component.Id} value={component.Id} onClick={() => handleVisibleOn(component.Id)}> {component.Value}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                       
                        <FormControl
                            size="small"
                            fullWidth
                        >
                            <Autocomplete
                                fullWidth
                                multiple
                                size="small"
                                label="Department"
                                id="department"
                                value={selectedDepartment.filter((option) =>
                                    department.includes(option.Id)
                                )}
                                onChange={(_, newValue) => {
                                    const selectedIds = newValue.map((item) => item.Id);
                                    handleDepartment(selectedIds); 
                                }}
                                options={selectedDepartment}
                                getOptionLabel={(option) => option.TeamName || ""}
                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                renderInput={(params) => <TextField {...params} label="Department" />}
                                limitTags={2}
                            />
                        </FormControl>
                        <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={1}>

                            <Tooltip title="Filter">

                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={onFilterClick}

                                ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                            </Tooltip>
                            <Tooltip title="Add New">

                                <Button
                                    onClick={handleOpenModal}
                                    variant="contained"
                                    size="small"
                                ><Icon icon="ic:baseline-plus" width="25px" height="25px" /></Button>

                            </Tooltip >
                            <Modal open={editModal} onClose={handleCloseModal}>
                                <Box sx={modalStyle}>
                                   
                                    <Stack spacing={3}>

                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Reason "
                                            multiline
                                            maxRows={2}
                                            value={rowReasonTxt}
                                            onChange={handleRowReason}
                                        />
                                        <FormControl
                                            fullWidth
                                            size="small">
                                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Visible On</InputLabel>
                                            <Select
                                                label="Visible On"
                                                size="small"
                                                value={rowVisibleOn}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: '#fbe9e7', // Set the background color here
                                                            maxHeight: '200px',
                                                            width: '200px',// Set the max height here
                                                        }
                                                    }
                                                }}>
                                                <MenuItem key={0} value={""} onClick={() => handleRowVisibleOn()}  >Select</MenuItem>
                                                {visibleOnData.map((component) => (
                                                    <MenuItem key={component.Id} value={component.Id} onClick={() => handleRowVisibleOn(component.Id)}> {component.Value}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl
                                            fullWidth
                                            size="small">
                                            <Autocomplete
                                                fullWidth
                                                multiple
                                                size="small"
                                                label="Department"
                                                id="department"
                                                value={rowSelectedDepartment.filter((option) =>
                                                    rowDepartment.includes(option.Id)
                                                )}
                                                onChange={(_, newValue) => {
                                                    const selectedIds = newValue.map((item) => item.Id);
                                                    handleRowDepartment(selectedIds);
                                                }}
                                                options={rowSelectedDepartment}
                                                getOptionLabel={(option) => option.TeamName || ""}
                                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                renderInput={(params) => <TextField {...params} label="Department" />}
                                                limitTags={2}
                                            />
                                        </FormControl>

                                        <Stack direction="row" justifyContent="center" spacing={2} mt={4}>
                                            <Button
                                                size="medium"
                                                type="submit"
                                                variant="contained"
                                                sx={{ color: "white" }}
                                                onClick={handleRCASave}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                sx={{ color: "white" }}
                                                onClick={handelCancelClick}
                                                size="medium"
                                                variant="contained"
                                                color="primary"
                                            >
                                                Cancel
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Box>
                               
                            </Modal>
                            <Tooltip title="Reset">

                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleReset}
                                ><Icon icon="ic:twotone-restart-alt" width="25px" height="25px" /></Button>

                            </Tooltip >

                        </Stack>
                    </Stack>
                    <Divider />

                    {/* ----------------------------------------------------------------- */}

                    <div style={{ height: '73vh', width: '100%' }}>
                        <DataGrid rows={rcaData} density={'compact'} columns={firstSectionColumn} getRowId={(row) => rcaData.indexOf(row)} components={{
                            Toolbar: GridToolbar,
                        }} rowsPerPageOptions={[25, 50, 100]}
                            pagination
                            paginationMode="client"
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        />
                    </div>

                </Card>
                {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}


                {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}
            </Page>

        );
    }

